<div class="awards block" *ngIf="selectedClass" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="awards__title">
    <span><b>Награждение</b></span>
    <span>|</span>
    <span>
      <mat-form-field>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>
  </div>
  <div class="awards__form">
    <div class="awards__profiles">
      <ul>

        <li class="awards__profiles__item">
          <span>
            <mat-checkbox [checked]="selectedAllStudents" (change)="selectAllStudents()"></mat-checkbox> Все
          </span>
        </li>

        <li *ngFor="let student of students; let i = index;" class="awards__profiles__item" [class.selected]="student.select || selectedStudent === student">
          <span>
            <mat-checkbox color="primary"
                [checked]="student.select"
                (change)="selectStudent(student)"></mat-checkbox>
          </span>

          <span class="awards__profiles__item__user" (click)="editUserAwards(student)">
            <span>{{ i + 1 }}.&#xa0;</span>
            <app-profile-user
              [student]="student"
            ></app-profile-user>
          </span>
        </li>

      </ul>
    </div>
    <div *ngIf="isAwardSettings" class="awards__settings">
      <div class="awards__settings__stepper">

        <mat-form-field>
          <mat-label>Событие</mat-label>
          <mat-select placeholder="Вид награды" formControlName="award_event" (selectionChange)="getEventAwardCards()">
            <mat-option *ngFor="let award_event of awardEvents" [value]="award_event.id">
              {{ award_event.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="tournaments.length > 0">
          <mat-label>Выберите турнир</mat-label>
          <mat-select placeholder="Вид награды" formControlName="tournament">
            <mat-option *ngFor="let tournament of tournaments" [value]="tournament.id">
              {{ tournament.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>За что *</mat-label>
          <textarea matInput formControlName="for_what"></textarea>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Комментарий</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>

        <ul class="awards__settings__stepper__links">
          <li *ngFor="let link of filesLinks">
            <a href="{{ link }}" target="_blank" (click)="showLink(link)"><span class="material-icons">link</span></a>
          </li>
          <button mat-button class="awards__settings__stepper__links__default" (click)="addLink()">
            <span class="material-icons">link</span>
            <span>Добавить ссылку</span>
          </button>
        </ul>

        <mat-form-field class="link-form-field">
          <mat-label>Ссылка на файлы</mat-label>
          <input type="url" matInput formControlName="url" (keyup.enter)="addLink()"/>
          <mat-icon matSuffix (click)="deleteCurrentLink()">close</mat-icon>
        </mat-form-field>

        <div>Кол-во награждаемых *: <i color="#6795c5">{{ countSelectStudents }} чел.</i></div>

      </div>
      <div *ngIf="eventAwards.length > 0" class="awards__settings__award">
        <p>Награда</p>
        <ul *ngIf="!choosesCard">
          <li *ngFor="let award of eventAwards">
            <div class="awards__settings__award__wrapper" (click)="chooseCard(award)" [class.active]="award === choosesCard">
              <img src="{{ award.preview?.url }}" alt="{{ award.title }}">
            </div>
          </li>
        </ul>

        <div *ngIf="choosesCard" class="chooses-card awards__settings__award__wrapper">
          <div class="chooses-card__head">
            <span class="chooses-card__head__title">{{ choosesCard.title }}</span>
            <span class="chooses-card__head__close" (click)="choosesCard = null">
              <mat-icon>close</mat-icon>
            </span>
          </div>
          <div class="chooses-card__body">
            <img src="{{ choosesCard.preview?.url }}" alt="{{ choosesCard.title }}">
          </div>
        </div>

      </div>
    </div>

    <ng-container *ngIf="isProfileAwards">
      <app-profile-awards
        [student]="selectedStudent"
        (navBack)="isAwardSettings = true; selectedStudent = null; isProfileAwards = false"
        (editAward) = "editAward()"
      ></app-profile-awards>
    </ng-container>

    <ng-container *ngIf="isEditAward">
      <app-page-item [forTeacher]="true" (deleteAwardEmitter)="deleteAwardHandler()"></app-page-item>
    </ng-container>
  </div>

  <div *ngIf="isAwardSettings" class="awards__confirm">
    <button mat-raised-button type="submit" (click)="onSubmit()"
        [disabled]="!form.valid || !countSelectStudents || !choosesCard">Подтвердить</button>
  </div>
</div>
